<div>
    <h3 class="title d-none d-lg-block" translate="Settings.AccountSecuritySection.Title"></h3>
    <h3 class="px-3 pt-4 pb-2 d-block d-lg-none" translate="Settings.AccountSecuritySection.Title"></h3>
</div>
<div class="pt-1 px-3 pb-1 p-lg-4 pb-lg-0 pt-lg-0">
    <div class="pb-4 pb-lg-0 pt-4">
        <span class="pt-5 col-12" translate="Settings.AccountSecuritySection.2FA"></span>
        <div class="mb-3 mt-2 mx-0 p-1 col-12 row text-wrap border rounded lh-base">
            <div class="d-table form-check form-switch">
                <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="authenticatorapp" name="authenticatorapp" (click)="authenticatorApp($event)" [disabled]="!securityMethods" [checked]="securityMethods?.hasAuthenticator">
                <label class="form-check-label pt-1 col-10" for="authenticatorapp" translate="Settings.AccountSecuritySection.EnableAuthApp"></label>
            </div>
        </div>
    </div>
</div>